import { BillingRequestService } from 'gocardless-nodejs/services/billingRequestService'

export type BillingRequestResponse = Awaited<ReturnType<typeof BillingRequestService.prototype.create>>

export interface GoCardlessBillingRequestResponse {
  flowUrl:string,
  billingRequestResponse: BillingRequestResponse
}